import {observer} from "mobx-react-lite";
import Competition from "./Competition";
import {useParams} from "react-router";
import {useEffect} from "react";
import clubStore from "../../../storage/ClubStore";

const EditCompetition = () => {
  const args = useParams();
  useEffect(() => {
    clubStore.tournament.getCompetition(args.id);
  }, [args.id])
  return (
      <Competition/>
  )
};

export default observer(EditCompetition)